import { Modal } from 'framework/ui/ui-builder';
import { FormActionType } from 'framework/ui/menu';

interface MilestonesModalsManagerProps {
  signal?: FormActionType | null;
  onClose: () => void;
}

const MilestonesModalsManager = ({ signal, onClose }: MilestonesModalsManagerProps) => {
  if (!signal) return null;

  return (
    <Modal
      isOpen={!!signal}
      title={signal.title}
      onToggle={onClose}
      hasCancelButton
      className="form-modal"
      modalSize={signal.modalSize ?? 'sm'}
      paperStyles={{ backgroundColor: 'var(--mui-palette-background-paper)' }}
    >
      <signal.Component modalOpen={!!signal} closeModal={onClose} afterSubmit={signal.afterSubmit} />
    </Modal>
  );
};

export default MilestonesModalsManager;
